if (!customElements.get('share-button')) {
  class ShareButton extends HTMLElement {
    constructor() {
      super();

      this.shareButton = this.querySelector('[data-share-button]');
      this.shareSummary = this.querySelector('summary');
      this.shareDetails = this.querySelector('details');
      this.copyButton = this.querySelector('[data-share-button-copy]');
      this.closeButton = this.querySelector('[data-share-button-close]');
      this.successMessage = this.querySelector('[data-share-button-message]');
      this.urlInput = this.querySelector('[data-share-button-url-input]');
      this.urlToShare = this.urlInput ? this.urlInput.value : document.location.href;

      this.shareButton.addEventListener('click', this.open.bind(this));
      this.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
      this.closeButton.addEventListener('click', this.close.bind(this));

      document.querySelectorAll('share-button').forEach((shareButton, index) => {
        shareButton.querySelector('label').setAttribute('for', `url-${index}`);
        shareButton.querySelector('input').setAttribute('id', `url-${index}`);
      });
    }

    open() {
      this.successMessage.value = '';
      this.urlInput.classList.remove('d-none');
      this.copyButton.classList.remove('d-none');
      this.successMessage.classList.add('d-none');
      this.closeButton.classList.add('d-none');
      this.shareSummary.focus();
    }

    close() {
      this.successMessage.value = '';
      this.urlInput.classList.add('d-none');
      this.copyButton.classList.add('d-none');
      this.successMessage.classList.remove('d-none');
      this.closeButton.classList.add('d-none');
      this.shareDetails.removeAttribute('open');
      this.shareButton.focus();
    }

    copyToClipboard() {
      navigator.clipboard.writeText(this.urlInput.value).then(() => {
        this.urlInput.classList.add('d-none');
        this.copyButton.classList.add('d-none');
        this.successMessage.classList.remove('d-none');
        this.successMessage.value = window.accessibilityStrings.shareSuccess;
        this.closeButton.classList.remove('d-none');
        this.closeButton.focus();
      });
    }

    updateUrl(url) {
      this.urlToShare = url;
      this.urlInput.value = url;
    }
  }

  customElements.define('share-button', ShareButton);
}